export const sizes = {
  container: {
    xl: '1400px',
  },
};
